import Yup from '@utils/yup';
import { ObjectShape } from 'yup/lib/object';

interface OptionProps {
  shortcut?: string;
  value?: string;
  label?: string;
}
export interface ValuesScriptData {
  title: string;
  valueName: string;
  options?: OptionProps[];
  schemeValidation?: Yup.ObjectSchema<ObjectShape>;
  placeholder?: string;
  populate?: boolean;
}
export const videoScriptSelectorData: ValuesScriptData = {
  title: 'What kind of video script do you need?',
  valueName: 'videoFor',
  options: [
    {
      shortcut: 'A',
      value: 'Looks like a good fit',
      label: 'Looks like a good fit',
    },
    {
      shortcut: 'B',
      value: 'Uses a competitor',
      label: 'Uses a competitor',
    },
    {
      shortcut: 'C',
      value: "Booked a demo but didn't show",
      label: "Booked a demo but didn't show",
    },
    {
      shortcut: 'D',
      value: 'Attended a webinar',
      label: 'Attended a webinar',
    },
    {
      shortcut: 'E',
      value: 'Engaged with a relevant LinkedIn post',
      label: 'Engaged with a relevant LinkedIn post',
    },
  ],
  populate: true,
  schemeValidation: Yup.object().shape({
    videoFor: Yup.string().required('Please select an option'),
  }),
};

export const viewerNextStepSelectorData: ValuesScriptData = {
  title: 'What should the viewer do next? ',
  valueName: 'nextToDo',
  options: [
    {
      shortcut: 'A',
      value: 'Schedule a meeting',
      label: 'Schedule a meeting',
    },
    {
      shortcut: 'B',
      value: 'Try it out',
      label: 'Try it out',
    },
    {
      shortcut: 'C',
      value: 'Visit website',
      label: 'Visit website',
    },
  ],
  populate: true,
  schemeValidation: Yup.object().shape({
    nextToDo: Yup.string().required('Please select an option'),
  }),
};

export const productNameStepTextInputData: ValuesScriptData = {
  title: 'What is your product or solution called?',
  valueName: 'productCalled',
  placeholder: 'i.e. Sendspark',
  populate: true,
  schemeValidation: Yup.object().shape({
    productCalled: Yup.string().required('Please add more details'),
  }),
};

export const productWebsiteStepTextInputData: ValuesScriptData = {
  title: 'What is [product name]\'s website URL?',
  valueName: 'productWebsite',
  placeholder:
    'i.e. https://sendspark.com',
  populate: true,
  schemeValidation: Yup.object().shape({
    productWebsite: Yup.string().required('Please add the product website').url('Please make sure you enter a valid URL and include http or https'),
  }),
};

export const workEmailTextInputData: ValuesScriptData = {
  title:
    'We’re almost ready to generate your script! Where should we update you?',
  valueName: 'workEmail',
  placeholder: 'Enter your work email…',
  populate: true,
  schemeValidation: Yup.object().shape({
    workEmail: Yup.string()
      .required('Please add your work email')
      .email('Please make sure you enter a valid e-mail address.'),
    'g-recaptcha-response': Yup.string().required(),
  }),
};
